import axios from "axios";
import { useEffect } from "react";
import { useQuery } from "react-query";
import { DropzoneFileStatus } from "../../components/Dropzone";
import { getBackendUrl } from "../../utils";
import {
  CustomerSpendUploadStatus,
  useCustomerSpendUpload,
} from "./useCustomerSpendUpload";

type CustomerSpendResponse = {
  organization: {
    id: string;
    name: string;
    linkLogoUrl: string | null;
    linkText: string | null;
  };
  customer_spend: {
    status: "processing" | "failure" | "success" | "idle";
    files: { id: string; name: string; size: number }[];
  };
};

export const useCustomerSpend = (connectionId: string) => {
  const { data, error, isLoading, isFetching } = useQuery({
    queryKey: ["@supplierEnablement/customerSpend", connectionId],
    suspense: false,
    retry: false,
    refetchOnWindowFocus: false,
    queryFn: async () => {
      const connections = await axios({
        baseURL: getBackendUrl(),
        url: `/versioned/connections/${connectionId}/customer_spend`,
        headers: {
          "Content-Type": "application/json",
          "X-Rutter-Version": "2023-02-07",
        },
      });

      return connections.data as CustomerSpendResponse;
    },
  });

  const { setStatus, setFiles } = useCustomerSpendUpload();

  useEffect(() => {
    if (data && data.customer_spend.status !== "idle") {
      setStatus(CustomerSpendUploadStatus.Success);
      setFiles(
        data.customer_spend.files.map((file) => ({
          id: file.id,
          name: file.name,
          size: file.size,
          status: DropzoneFileStatus.Success,
          progress: 100,
          binary: new File([], file.name),
        })),
      );
    }
  }, [data]);

  return {
    id: connectionId,
    data,
    error,
    isLoading,
    isFetching,
  };
};
